import React from 'react';
import { useSelector } from 'react-redux';
import ReduxHooks from '../../store/ReduxHooks';
import { actionCreators } from '../../store/actions';
import RefreshIcon from '../../resources/assets/icons/RefreshIcon';
import OrdersPausedManuallyBanner from '../banners/OrdersPausedManuallyBanner';
import OnlineStatusButton from '../buttons/OnlineStatusButton';
import { CloseOutlined, LoadingOutlined, MenuOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useStats } from '../../providers/StatsProvider';
import { useTranslation } from 'react-i18next';
import { useHelpers } from '../../providers/HelpersProvider';

const Header = () => {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Layout:Header' });

  const { company } = useSelector((state) => state.company);
  const { sidebar } = useSelector((state) => state);

  const { stats, loading } = useStats();
  const { formatCurrency } = useHelpers();

  return (
    <header className="sticky top-0 z-10 border-b bg-gray-50 border-gray-200 py-0">
      <div className="w-full flex justify-between gap-1 py-2 px-2">
        <div className="flex items-center gap-1">
          <Button
            type="text"
            icon={sidebar?.show ? <CloseOutlined /> : <MenuOutlined />}
            className="text-md"
            onClick={() => {
              ReduxHooks.dispatch(actionCreators.sidebar.toggle(!sidebar?.show));
            }}
          />
        </div>
        <div className="flex gap-lg">
          <Header.Metric
            name={t('stats.sales')}
            value={formatCurrency(stats.sales)}
            loading={loading || !company?.currency}
          />
        </div>
        <div className="flex justify-end items-center gap-2">
          {company?.has_pausing_orders_quick_access && <OnlineStatusButton />}
          <Button type="text" icon={<RefreshIcon className="h-8 w-8" />} onClick={() => window.location.reload()} />
        </div>
      </div>
      <OrdersPausedManuallyBanner />
    </header>
  );
};

export default Header;

Header.Metric = ({ name, value, loading }) => {
  return (
    <div>
      <span className="text-2xs text-gray-600 text-right w-full block">{name}</span>
      <span className="block font-bold text-md">{loading ? <LoadingOutlined spin /> : value}</span>
    </div>
  );
};
